const Colors = {
  // Основные цвета (теперь управляются через брендинг)
  white: "var(--background-light, #FFFFFF)",
  gray: "var(--text-light-color, #808080)",
  blue: "var(--secondary-color, #81a8ec)",
  red: "#FF3636", // Остается статичным
  gray2: "var(--border-color, #BCBCBC)",
  blue2: "var(--main-color, #4783ed)",
  black: "var(--text-dark-color, #242424)",
  violet: '#752c5b', // Остается статичным

  // Цвета оценок (остаются статичными)
  markRed: "#bd362f",
  markOrange: "#f89406",
  markYellow: "#FCD100",
  markGreen: "#51a351",

  // Новые цвета из брендинга
  primary: "var(--main-color, #4783ed)",
  secondary: "var(--secondary-color, #81a8ec)",
  text: "var(--text-color, #333333)",
  textLight: "var(--text-light-color, #666666)",
  textDark: "var(--text-dark-color, #000000)",
  textActive: "var(--text-active, #ffffff)",
  background: "var(--background-color, #f8f9fa)",
  backgroundLight: "var(--background-light, #ffffff)",
  backgroundDark: "var(--background-dark, #f0f0f0)",
  border: "var(--border-color, #dee2e6)",
  borderLight: "var(--border-light, #e9ecef)",
  borderDark: "var(--border-dark, #adb5bd)",
  success: "var(--success-color, #28a745)",
  error: "var(--error-color, #dc3545)",
  warning: "var(--warning-color, #ffc107)",
  info: "var(--info-color, #17a2b8)",
}

export default Colors